import React from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { useRemoveConsentModalContext } from 'pages/SharePage/Context/RemoveConsentModalContext';
import { useTabAreaContext } from 'pages/SharePage/Context/TabAreaContext';
import consentRequests from 'services/consentRequests';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';

import './RemoveConsentModal.css';

export function RemoveConsentModal() {
  const { removeConsentModalState, setRemoveConsentModalState } = useRemoveConsentModalContext();
  const { refetchTabArea } = useTabAreaContext();
  const initialStateModal = {
    isOpen: false,
    subjectId: 'Não Encontrado',
    pat_id: 'Não Encontrado',
    pat_name: 'Não Encontrado',
    consentType: 'Não Encontrado',
  };

  // removeConsent(subject, consent.pat_id, consent.pat_name)

  async function handleRemoveConsent(subjectId, patientId, consentType) {
    if (consentType === 0) await consentRequests.appc_request('Deny', subjectId, [patientId]);
    else await consentRequests.appc_request('Deny', subjectId, null, [patientId]);
    setRemoveConsentModalState(initialStateModal);
    refetchTabArea();
    toast.success(<ToastMessage type="success">Consentimento removido.</ToastMessage>);
  }

  return (

    <Dialog
      className="removeConsentModal"
      open={removeConsentModalState.isOpen}
      aria-labelledby="remove-dialog-title"
      aria-describedby="remove-dialog-description"
    >
      <DialogTitle id="remove-dialog-title">Remover Consentimento</DialogTitle>
      <DialogContent>
        <div className="removeConsentModal-text">
          <p>
            Atenção: ao confirmar essa ação
            <b>
              {' '}
              {removeConsentModalState.pat_name}
              {' '}
            </b>
            não terá mais acesso a suas informações de saúde.
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <button className="removeConsentModal-closeButton" onClick={() => setRemoveConsentModalState(initialStateModal)} type="button">
          Cancelar
        </button>
        <button className="removeConsentModal-removeButton" onClick={() => handleRemoveConsent(removeConsentModalState.subjectId, removeConsentModalState.pat_id, removeConsentModalState.consentType)} type="button">
          Sim
        </button>
      </DialogActions>
    </Dialog>

  );
}
